export function playOrderBell(times = 3) {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();

    const playBell = (startTime) => {
      const osc1 = ctx.createOscillator();
      const gain1 = ctx.createGain();
      osc1.connect(gain1);
      gain1.connect(ctx.destination);
      osc1.type = 'sine';
      osc1.frequency.setValueAtTime(880, startTime);
      osc1.frequency.exponentialRampToValueAtTime(440, startTime + 1.5);
      gain1.gain.setValueAtTime(0.8, startTime);
      gain1.gain.exponentialRampToValueAtTime(0.001, startTime + 1.5);
      osc1.start(startTime);
      osc1.stop(startTime + 1.5);

      const osc2 = ctx.createOscillator();
      const gain2 = ctx.createGain();
      osc2.connect(gain2);
      gain2.connect(ctx.destination);
      osc2.type = 'sine';
      osc2.frequency.setValueAtTime(1760, startTime);
      osc2.frequency.exponentialRampToValueAtTime(880, startTime + 1.0);
      gain2.gain.setValueAtTime(0.3, startTime);
      gain2.gain.exponentialRampToValueAtTime(0.001, startTime + 1.0);
      osc2.start(startTime);
      osc2.stop(startTime + 1.0);
    };

    for (let i = 0; i < times; i++) {
      playBell(ctx.currentTime + i * 0.7);
    }
  } catch (err) {
    console.warn('Bell sound failed:', err);
  }
}

export async function requestNotificationPermission() {
  if ('Notification' in window && Notification.permission === 'default') {
    await Notification.requestPermission();
  }
}

export function showOrderNotification(source, orderCount) {
  if ('Notification' in window && Notification.permission === 'granted') {
    new Notification(`🔔 New Order from ${source}!`, {
      body: `${orderCount} new order${orderCount > 1 ? 's' : ''} waiting to be processed.`,
      icon: '/favicon.ico',
      requireInteraction: true,
    });
  }
}